var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.5 2.5a2.5 2.5 0 0 1 5 0V6a2.5 2.5 0 0 1-5 0V2.5zM3 6v-.5h1V6a3 3 0 0 0 6 0v-.5h1V6a4 4 0 0 1-3.5 3.969V12H10v1H4v-1h2.5V9.969A4 4 0 0 1 3 6z",
  clipRule: "evenodd"
})));
export { SvgAudio as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC41IDIuNWEyLjUgMi41IDAgMCAxIDUgMFY2YTIuNSAyLjUgMCAwIDEtNSAwVjIuNXpNMyA2di0uNWgxVjZhMyAzIDAgMCAwIDYgMHYtLjVoMVY2YTQgNCAwIDAgMS0zLjUgMy45NjlWMTJIMTB2MUg0di0xaDIuNVY5Ljk2OUE0IDQgMCAwIDEgMyA2eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";